<div class="ui-dt__toolbar">
  <div class="ui-dt__toolbar-start">
    @if (showExcel()) {
      <ui-button
        variant="document"
        iconSrc="/icons/ic_doc_xls.svg"
        ariaLabel="Descargar Excel"
        [uiTooltip]="'Descargar Excel'"
        uiTooltipPosition="top"
        (pressed)="onExportExcel()"
      />
    }

    @if (hasStatusFilter()) {
      <ui-filter-menu
        [filters]="statusFilters()"
        (change)="onFilterMenuChange($event)"
      />
    }

    @for (group of segmentedFilters(); track group.key) {
      <ui-segmented-filter
        [label]="group.label"
        [options]="group.options"
        [value]="group.value"
        (valueChange)="onSegmentedFilterChange(group.key, $event)"
      />
    }
  </div>

  <div class="ui-dt__toolbar-end">
    <!-- Slot para proyectar variantes de select/multiselect (ui-year-multiselect, ui-month-multiselect, etc.) -->
    <ng-content select="[data-toolbar-selects]"></ng-content>

    @for (ts of toolbarSelects(); track ts.key) {
      @if (ts.type === 'select') {
        <ui-select
          [showLabel]="false"
          [showOptionalHint]="false"
          [placeholder]="ts.hint"
          [options]="ts.options"
          [selected]="tsSingleCurrentSelected(ts.key)"
          (selectedChange)="onTsSingleSelectionChange(ts.key, $event)"
          [style.width.px]="ts.width ?? 160"
        />
      } @else {
        <ui-multiselect
          #tsMs
          [showLabel]="false"
          [placeholder]="ts.hint"
          [options]="ts.options"
          [selected]="tsCurrentSelected(ts.key)"
          (selectedChange)="onTsSelectionChange(ts.key, $event)"
          (opened)="closeOtherMultiselects(tsMs)"
          [block]="false"
          [style.width.px]="ts.width ?? 240"
        />
      }
    }

    @if (showPageSize()) {
      <ui-select
        [showLabel]="false"
        [showSearch]="false"
        [allowClear]="false"
        [options]="pageSizeOptions()"
        [selected]="selectedSizeOption()"
        (selectedChange)="onSizeChange($event)"
        (opened)="closeAllMultiselects()"
        [style.width.px]="145"
      />
    }

    <ng-content select="[data-toolbar-actions]"></ng-content>

    @if (showNewButton()) {
      <ui-button (click)="onNew()">{{ newLabel() }}</ui-button>
    }
  </div>
</div>

